import _ from "lodash";

export default {
    props: ['defaultValue', 'format'],

    data() {
        return {
            iti: null,
        }
    },

    methods: {
        formatValueDefault(iti, input) {
            let fullNumber = input.value.split(/ (.*)/s);
            let countryData = iti.getSelectedCountryData()
            let dialCode = ('00' + countryData.dialCode).slice(-4);

            let formattedValue = '';
            if (fullNumber.length > 1) {
                let prefixCode = fullNumber[0];
                let remainingNumbers = fullNumber[1].replace(/ |-|_/g, '');

                formattedValue = dialCode+'/'+prefixCode+'/'+remainingNumbers;
            }

            return formattedValue;
        },

        formatValueStandard(iti, input) {
            let fullNumber = input.value.split(/ (.*)/s);
            let countryData = iti.getSelectedCountryData()
            let dialCode = countryData.dialCode.slice(-2);

            let formattedValue = '';
            if (fullNumber.length > 1) {
                let prefixCode = fullNumber[0];
                let remainingNumbers = fullNumber[1].replace(/ |-|_/g, '');

                formattedValue = dialCode+prefixCode+remainingNumbers;
            }

            return formattedValue;
        },

        formatValue(iti, input) {
            if (this.format == 'standard') {
                return this.formatValueStandard(iti, input);
            }

            return this.formatValueDefault(iti, input);
        },

        createPhoneInput() {
            const input = this.$el;

            if (input) {
                input.addEventListener('change', (event) => {
                    let formattedValue = this.formatValue(this.iti, input);

                    this.$emit('updateValue', formattedValue);
                });

                this.iti = intlTelInput(input, {
                    separateDialCode: true,
                    strictMode: true,
                    formatOnDisplay: true,
                    nationalMode: false,
                    validationNumberType: 'MOBILE',
                    initialCountry: 'ch',
                    onlyCountries: ['ch'],
                    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@23.3.2/build/js/utils.js",
                });
            }
        },

        setDefaultValue() {
            if (this.defaultValue) {
                this.iti.setNumber(this.defaultValue);
            }
        }
    },

    mounted() {
        this.createPhoneInput();
        this.setDefaultValue();
    },

    watch: {
        "defaultValue": _.debounce(function () {
            this.setDefaultValue();
        }, 500)
    }
};
